import MiniLazyload, { TMiniLazyload, ICNCMiniLazyloadOptions } from 'minilazyload';

const animatedPlaceholder = (images: NodeListOf<HTMLImageElement>) => {
  [...images].forEach((image: HTMLImageElement) => {
    const parentEl = image.parentElement;
    const magazineName = image.dataset.magazine ? image.dataset.magazine : 'default';
    const PLACEHOLDER_CLASS = 'loading-placeholder';

    // Obrázek se stihl načíst (například z cache) než jsme se k němu dostali v JS
    if (parentEl && image.complete) {
      parentEl.classList.add(`${PLACEHOLDER_CLASS}--loaded`);
      return;
    }

    if (parentEl) {
      image.addEventListener('load', () => {
        parentEl.classList.add(`${PLACEHOLDER_CLASS}--loaded`);
      });

      image.addEventListener('error', () => {
        parentEl.classList.add(`${PLACEHOLDER_CLASS}--error`);
        parentEl.style.backgroundOrigin = `/dist-isport/assets/${magazineName}/image-placeholder.png`;
      });
    }
  });
};

/**
 * Replace data-src for src
 */
const ieFallbackDataSrcReplacement = (images: NodeListOf<HTMLImageElement>) => {
  [...images].forEach((image: HTMLImageElement) => {
    image.setAttribute('src', image.getAttribute('data-src') as string);
  });
};

export const CncMiniLazyLoad = (props: ICNCMiniLazyloadOptions) => {
  const { lazyLoadedImages } = props;
  const LAZY_LOAD_SELECTOR = '.lazyload';

  /* Fallback for IE10 */
  if (navigator.userAgent.match(/MSIE 10/)) {
    ieFallbackDataSrcReplacement(lazyLoadedImages);

    /* Animated placeholder */
    animatedPlaceholder(lazyLoadedImages);

    return;
  }

  animatedPlaceholder(lazyLoadedImages);

  window.prepareLazyLoad = new CustomEvent('prepareLazyLoad', {
    // Detail v CustomEventu je defaultně typ 'any', je tedy třeba ho při volání ošetřit
    detail: () => {
      const preparedImages: NodeListOf<HTMLImageElement> = document.querySelectorAll('.lazyload');
      animatedPlaceholder(preparedImages);
    },
  });

  window.cncImageLazyload = new (MiniLazyload as TMiniLazyload)(
    { rootMargin: '500px', ...props },
    LAZY_LOAD_SELECTOR,
    true
  );
};

export default CncMiniLazyLoad;
